<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		@show="showModal"
		:title="
			modelId > 0 ? 'Edición de plan tarifario' : 'Nuevo plan tarifario'
		"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-form @submit="onSubmit">
			<b-form-row>
				<b-form-group :class="!showSuppliers ? 'col-4' : 'col-12'" label="Nombre*">
					<b-form-input
						type="text"
						size="sm"
						:disabled="unableEdit"
						v-model="modelInfo.name"
						required
					/>
				</b-form-group>
				<b-form-group class="col-8" label="Tarifa padre" v-if="!embbebedOnSupplier && !showSuppliers">
					<!-- <b-form-select size="sm" v-model="modelInfo.parentRatePlanId" :options="inheritableRatePlansOpts"></b-form-select> -->
					<multiselect
						:disabled="
							!$hasPermission('prices.inherited') || unableEdit
						"
						@select="toggleSelected"
						:options="inheritableRatePlansOpts"
						v-model="modelInfo.parentRatePlanObj"
						:multiple="false"
						:close-on-select="true"
						:show-labels="false"
						label="text"
						track-by="value"
					/>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group
					v-if="modelInfo.parentRatePlanId"
					class="col-4"
					label="Modificacion de herencia"
				>
					<b-input-group>
						<b-input-group-prepend>
							<b-form-select
								size="sm"
								:disabled="
									!$hasPermission('prices.inherited') ||
										unableEdit
								"
								v-model="modelInfo.heritanceModifierSign"
								:options="[
									{ value: 1, text: '+' },
									{ value: -1, text: '-' }
								]"
							/>
						</b-input-group-prepend>
						<b-form-input
							type="text"
							size="sm"
							:disabled="
								!$hasPermission('prices.inherited') ||
									unableEdit
							"
							v-model="modelInfo.heritanceModifierAmount"
							required
						/>
						<b-input-group-append>
							<b-form-select
								size="sm"
								:disabled="
									!$hasPermission('prices.inherited') ||
										unableEdit
								"
								v-model="modelInfo.heritanceModifierType"
								:options="[
									{ value: '%', text: '%' },
									{ value: '$', text: '$' }
								]"
							/>
						</b-input-group-append>
					</b-input-group>
				</b-form-group>
				<template v-else>
					<b-form-group class="col-3" label="Moneda">
						<b-form-select
							size="sm"
							:disabled="unableEdit"
							v-model="modelInfo.currency"
							:options="currencyOptions"
						></b-form-select>
					</b-form-group>
					<b-form-group class="col-4" label="Area Shuttle Central*">
						<multiselect
							v-if="!embbebedOnSupplier"
							:disabled="unableEdit"
							@select="toggleSelectedArea"
							:options="$root.auxVars.zonedAreasOpts"
							v-model="modelInfo.zonedAreaObject"
							:multiple="false"
							ref="zonedArea"
							:show-labels="false"
							label="text"
							track-by="value"
						/>
						<multiselect
							v-else
							:disabled="unableEdit"
							@select="toggleSelectedArea"
							:options="zonedAreaMaster"
							v-model="modelInfo.zonedAreaObject"
							:multiple="false"
							ref="zonedArea"
							:show-labels="false"
							label="text"
							track-by="value"
						/>
					</b-form-group>
					<b-form-group v-show="showSuppliers" class="col-4" label="Area Proveedor*">
						<multiselect
							:disabled="unableEdit"
							@select="toggleSelectedSupplierArea"
							:options="$root.auxVars.zonedAreasOpts"
							v-model="modelInfo.supplierZonedAreaObject"
							:multiple="false"
							ref="supplierZA"
							:show-labels="false"
							label="text"
							track-by="value"
						/>
					</b-form-group>
				</template>
				<b-form-group class="col-3" label="Tipo">
					<b-form-select
						:disabled="unableEdit"
						size="sm"
						v-model="modelInfo.rateType"
						:options="rateTypeOptions"
					></b-form-select>
				</b-form-group>
				<b-form-group class="col-2" label="Descuento">
					<b-input-group size="sm">
						<b-form-input
							:disabled="unableEdit"
							type="number"
							step="0.01"
							size="sm"
							v-model="modelInfo.percentageDiscount"
							required
						/>
						<template #append>
							<b-input-group-text>%</b-input-group-text>
						</template>
					</b-input-group>
				</b-form-group>
			</b-form-row>
			<b-form-row v-if="!embbebedOnSupplier">
				<b-form-group
					class="col-6"
					label="Asignacion automatica de Proveedor"
				>
					<b-form-select
						size="sm"
						:disabled="unableEdit"
						v-model="modelInfo.defaultSupplierId"
						:options="suppliersOpts"
					/>
				</b-form-group>
				<b-form-group class="col-3" label="Operacion externa">
					<b-form-select
						size="sm"
						:disabled="unableEdit"
						v-model="modelInfo.externallyOperatedServices"
						:options="[
							{ text: 'SI', value: true },
							{ text: 'NO', value: false }
						]"
					/>
				</b-form-group>
				<b-form-group class="col-3" label="Tipo de tarifa">
					<b-form-select
						size="sm"
						:disabled="unableEdit"
						v-model="modelInfo.type"
						:options="ratePlanTypeOpts"
					></b-form-select>
				</b-form-group>
			</b-form-row>

			<b-form-group label="Tipos de servicio (Opcional)" v-if="!embbebedOnSupplier">
				<multiselect
					class="stacked-options"
					:disabled="unableEdit"
					:options="servicesTypes"
					v-model="serviceTypesSelected"
					multiple
					label="text"
					track-by="value"
					taggable
					required
				/>
			</b-form-group>
			<b-form-group label="Tipos de servicio (Opcional)" v-else>
				<multiselect
					class="stacked-options"
					:disabled="unableEdit"
					:options="serviceTypesBySupplierId"
					v-model="serviceTypesSelected"
					multiple
					label="text"
					track-by="value"
					taggable
				/>
			</b-form-group>
			<hr />
			<b-form-row v-if="selectedParentRatePlan !== null">
				<b-form-group class="col-6">
					<FormGroupBox title="Datos de tarifa padre">
						<p class="mb-0">
							Área: {{ selectedParentRatePlan.zonedArea.name
							}}<br />
							Moneda: {{ selectedParentRatePlan.currency }}<br />
							Tipos de servicio:<br />
						</p>
						<ul>
							<li
								v-for="serviceType in selectedParentRatePlan.serviceTypes"
								:key="serviceType.id"
							>
								{{ serviceType.name }},
							</li>
						</ul>
					</FormGroupBox>
				</b-form-group>
			</b-form-row>
			<b-form-row v-if="showSuppliers || showSalesChannels">
				<b-col>
					<b-form-group label="Fecha de apertura*">
						<b-form-datepicker
							v-model="modelInfo.startDate"
						></b-form-datepicker>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Fecha de cierre(Opcional)">
						<b-form-datepicker
							v-model="modelInfo.endDate"
						></b-form-datepicker>
					</b-form-group>
				</b-col>
			</b-form-row>
			<b-form-row>
				<b-form-group class="col-6" label="Descripcion (Opcional)">
					<b-textarea size="sm" v-model="modelInfo.description" />
				</b-form-group>
			</b-form-row>

			<template v-if="showSuppliers || showSalesChannels">
				<b-form-row>
					<b-col>
						<b-form-group v-if="showSuppliers" label="Proveedor">
							<b-form-select
								disabled
								size="sm"
								v-model="modelInfo.supplierId"
								:options="suppliersOpts"
							></b-form-select>
						</b-form-group>
						<b-form-group
							v-if="showSalesChannels"
							label="Canal de venta"
						>
							<b-form-select
								disabled
								size="sm"
								v-model="modelInfo.salesChannelId"
								:options="salesChannelsOpts"
							></b-form-select>
						</b-form-group>
					</b-col>
					<b-col> </b-col>
				</b-form-row>
			</template>
			<hr />
			<div class="text-right">
				<b-button
					:disabled="unableEdit"
					variant="primary"
					type="submit"
					>{{ modelId > 0 ? "Actualizar" : "Guardar" }}</b-button
				>
			</div>
		</b-form>
	</b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import FormGroupBox from "../../helpers/FormGroupBox";
import moment from "moment";

export default {
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		},
		embbebedOnSupplier: Boolean,
		supplierId: Number,
		unableEdit: Boolean
	},
	components: { Multiselect, FormGroupBox },
	data() {
		let defaultModelInfo = {
			id: -1,
			name: "",
			currency: "mxn",
			description: "",
			zonedAreaId: null,
			supplierZonedAreaId: null,
			zonedAreaObject: null,
			supplierZonedAreaObject: null,
			rateType: "net",
			percentageDiscount: 0,
			type: "sc",

			parentRatePlanId: null,
			parentRatePlanObj: { value: null, text: "SIN HERENCIA" },
			heritanceModifierSign: 1,
			heritanceModifierType: "%",
			heritanceModifierAmount: 0,
			externallyOperatedServices: false,

			serviceTypes: [],
			supplierId: null,
			defaultSupplierId: null,
			salesChannelId: null,
			status: "active",

			startDate: null,
			endDate: null
		};
		return {
			modelId: -1,
			loading: true,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			currencyOptions: [
				{ value: "mxn", text: "MXN" },
				{ value: "usd", text: "USD" },
				{ value: "eur", text: "EUR" }
			],
			rateTypeOptions: [
				{ value: "net", text: "Tarifa Neta" },
				{ value: "public", text: "Tarifa Publica" }
			],
			ratePlanTypeOpts: [
				{ value: "sc", text: "Shuttle Central" },
				{ value: "jayride", text: "Jayride" }
			],
			serviceTypesBySupplierId: [],
			zonedAreaMaster: [],
			showSuppliers: false,
			showSalesChannels: false,
			inheritableRatePlans: []
		};
	},
	computed: {
		inheritableRatePlansOpts() {
			return [
				{ value: null, text: "SIN HERENCIA" },
				...this.inheritableRatePlans.map(rp => ({
					value: rp.id,
					text: rp.title
				}))
			];
		},
		selectedParentRatePlan() {
			if (this.modelInfo.parentRatePlanObj == null) return null;
			const aux = this.inheritableRatePlans.find(
				rp => rp.id == this.modelInfo.parentRatePlanId
			);
			return typeof aux === "undefined" ? null : aux;
		},
		serviceTypesSelected: {
			get: function() {
				return this.modelInfo.serviceTypes.map(st => ({
					value: st.id,
					text: st.name
				}));
			},
			set: function(value) {
				this.modelInfo.serviceTypes = value.map(st => ({
					id: st.value,
					name: st.text
				}));
			}
		},
		salesChannelsOpts() {
			return [
				{ value: null, text: "N/A" },
				...this.$root.auxVars.salesChannelsOpts
			];
		},
		suppliersOpts() {
			return [
				{ value: null, text: "N/A" },
				...this.$root.auxVars.suppliersOpts
			];
		},
		servicesTypes() {
			let services = {};
			if (this.modelInfo.parentRatePlanId != null) {
				const aux = this.inheritableRatePlans.find(
					rp => rp.id == this.modelInfo.parentRatePlanId
				);
				let aux2 = typeof aux === "undefined" ? null : aux;

				services = aux2?.serviceTypes.map(st => ({
					value: st.id,
					text: "[" + st.id + "] " + st.code
				}));
			} else {
				services = this.$root.auxVars.serviceTypesOpts.map(st => ({
					value: st.value,
					text: "[" + st.value + "] " + st.text
				}));
			}

			return services || [];
		},
		zonedModel: {
			get() {
				return this.modelInfo.zonedAreaObject;
			},

			set(value) {
				let result = this.$root.auxVars.zonedAreasOpts.find(
					za => za.value == value.value
				);
				this.$refs.zonedArea?.$emit("input", result);
			}
		},
		supplierZonedModel: {
			get() {
				return this.modelInfo.supplierZonedAreaObject;
			},

			set(value) {
				let result = this.$root.auxVars.zonedAreasOpts.find(
					za => za.value == value.value
				);
				this.$refs.supplierZA?.$emit("input", result);
			}
		},
	},
	methods: {
		toggleSelected(selectedOption) {
			this.modelInfo.parentRatePlanId = selectedOption.value;
			this.serviceTypesSelected = []
		},
		toggleSelectedArea(selectedOption) {
			this.modelInfo.zonedAreaId = selectedOption.value;
		},
		toggleSelectedSupplierArea(selectedOption) {
			this.modelInfo.supplierZonedAreaId = selectedOption.value;
		},
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			if (
				!this.modelInfo.parentRatePlanId &&
				(this.modelInfo.zonedAreaObject == null ||
					this.modelInfo.zonedAreaObject.lenght <= 0)
			) {
				this.$root.showAlert("Se debe seleccionar un Area", {
					variant: "warning"
				});
				return;
			}

			if (!this.modelInfo.parentRatePlanId && (this.modelInfo.supplierZonedAreaObject == null ||
					this.modelInfo.supplierZonedAreaObject.lenght <= 0) && this.showSuppliers) {
				this.$root.showAlert("Se debe seleccionar un Area de proveedor", {
					variant: "warning"
				});
				return;
			}
			//ingreso desde supplier(proveedor)?
			if (this.showSuppliers) {
				//validamos las fechas
				if (this.modelInfo.startDate == null) {
					this.$root.showAlert(
						"Se debe seleccionar una fecha de inicio  para la expiración",
						{
							variant: "warning"
						}
					);
					return;
				}
				// agregamos la hora a las 2 fechas, si es que no la tiene
				console.log(
					this.modelInfo.startDate +
						" :" +
						this.modelInfo.startDate.split(" ")[1] +
						" - " +
						this.modelInfo.endDate
				);
			}

			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/rate-plans/${this.modelId}`
						: "/rate-plans",
				method: this.modelId > 0 ? "put" : "post"
			};
			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = this.modelInfo;
			}
			this.$root.api
				.request(rParams)
				.then(res => {
					//validamos que sea una respuestas 200 o 2001 del lado del servidor
					if (res.status == 200 || res.status == 201) {
						this.$root.showAlert("OK!");
						if (res.data.id) this.loadModel(res.data.id);
						this.successCallback(res);
						this.$root.auxVars.resetResource("ratePlansOpts");
					}
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.loadInheritableRates();
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		loadInheritableRates() {
			if (!this.showSuppliers) {
				this.$root.api
					.get(`/rate-plans-inheritables`)
					.then(res => {
						this.inheritableRatePlans = res.data;
					})
					.catch(this.$root.handleRequestError);
			}
		},
		fetchModel() {
			if (this.modelId > 0) {
				this.$emit(
					"update:unableEdit",
					!this.$hasPermission("rates.edit")
				);
				this.loading = true;
				this.$root.api
					.get(`/rate-plans/${this.modelId}`)
					.then(res => {

						this.modelInfo = { ...res.data, serviceTypes: res.data.serviceTypes.map(st => ({
							id: st.id,
							name: "[" + st.id + "] " + st.code
						}))};

						if (this.modelInfo.parentRatePlanId == null) {
							this.modelInfo.parentRatePlanObj = {
								value: null,
								text: "SIN HERENCIA"
							};
						} else {
							this.modelInfo.parentRatePlanObj = {
								value: this.modelInfo.parentRatePlanId,
								text: this.modelInfo.parentRatePlanTitle
							};
						}

						if (this.modelInfo.zonedAreaId != null) {
							let result = this.$root.auxVars.zonedAreasOpts.find(
								za => za.value == this.modelInfo.zonedAreaId
							);
							this.$refs.zonedArea?.$emit("input", result);
						}

						if (this.modelInfo.supplierZonedAreaId != null) {
							let result2 = this.$root.auxVars.zonedAreasOpts.find(
								za => za.value == this.modelInfo.supplierZonedAreaId
							);

							this.$refs.supplierZA?.$emit("input", result2);
						}

						if (this.modelInfo.supplierId > 0)
							this.showSuppliers = true;
						if (this.modelInfo.salesChannelId > 0)
							this.showSalesChannels = true;
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		},
		setSupplierId(supplierId) {
			this.modelInfo.supplierId = supplierId;
			this.showSuppliers = true;
		},
		setSalesChannelId(salesChannelId) {
			this.modelInfo.salesChannelId = salesChannelId;
			this.showSalesChannels = true;
		},
		getMasterZonedAreas() {
			this.zonedAreaMaster = []
			this.$root.api
				.get(`zoned-areas/master`)
				.then(({data})=>{
					this.zonedAreaMaster = data.map(item => ({value: item.id, text: item.name}))
				})
				.catch((e)=> {
					console.error('ERROR => load master zoned areas', e.message)
				})
		},
		loadServiceTypeBySupplierId() {
			this.$root.api.get('/service-types', {
				params: {
					limit: 2001,
					filters: {
						config: {
							belongsTo: "supplier",
							supplierId: this.supplierId
						}
				} },
			}).then(response => {
				const rows = response.data.rows || response.data;
				this.serviceTypesBySupplierId = rows.map(item => ({
					value: item.id,
					text: item.code
				}));
			})
		},
		showModal() {
			if (this.embbebedOnSupplier) {
				this.loadServiceTypeBySupplierId()
				this.getMasterZonedAreas()
			}
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: [
				"zonedAreasOpts",
				"salesChannelsOpts",
				"suppliersOpts",
				"serviceTypesOpts"
			]
		});

		this.modelInfo.startDate = moment(new Date().toDateString()).format(
			"YYYY-MM-DD"
		);
		this.modelInfo.endDate = moment(new Date().toDateString()).format(
			"YYYY-MM-DD"
		);
		// console.log(this.modelInfo);
	},
	watch: {}
};
</script>

<style>
.stacked-options .multiselect__tag {
	float: left;
}
</style>
